import { getHTMLFromFragment } from './utils/index.js';
export class ChangeEvent {
    constructor(newState, tr) {
        this.state = newState;
        this.steps = tr.steps;
        this.docs = tr.docs;
        this.docChanged = tr.docChanged;
        this.selectionSet = tr.selectionSet;
    }
    /**
     * 合并一个新的 Change 事件，返回合体数据
     */
    merge(e) {
        return new ChangeEvent(e.state, {
            steps: [...this.steps, ...e.steps],
            docs: [...this.docs, ...e.docs],
            docChanged: e.docChanged || this.docChanged,
            selectionSet: e.selectionSet || this.selectionSet,
        });
    }
    toString() {
        return getHTMLFromFragment(this.state.doc.content, this.state.schema);
    }
}
//# sourceMappingURL=events.js.map